import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { StyledCheckbox } from "components/Form/FormikControls";
import { Row } from "components/Layout";
import React from "react";

interface Report {
  title: string;
  slug: string;
}

interface ReportSendingProps {
  report: Report;
  onToggle: () => void;
  selectedBillingDocumentReportSlugs: Array<string>;
}

export const ReportSendingList = ({
  report,
  onToggle,
  selectedBillingDocumentReportSlugs,
}: ReportSendingProps) => {
  return (
    <Row key={report.slug} justifyBetween fullWidth>
      <ListItem
        key={report.slug}
        dense
        disableGutters
        button
        onClick={onToggle}
      >
        <ListItemIcon>
          <StyledCheckbox
            edge="start"
            checked={selectedBillingDocumentReportSlugs.includes(report.slug)}
            tabIndex={-1}
            disableRipple
            inputProps={{ "aria-labelledby": report.title }}
          />
        </ListItemIcon>
        <ListItemText id={report.slug} primary={report.title} />
      </ListItem>
    </Row>
  );
};
